import CustomerUptimeListResourcePagingResultModel from '../../generated/types/model/resource/CustomerUptimeListResourcePagingResultModel';

export default class CustomerUptimeListResourcePagingResultViewModel extends CustomerUptimeListResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
